/**
 * Copyright (c) 2020 CA. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

import { get } from 'lodash';

export default ({ color, typography }) => ({
  SelectWrapper: {
    fontFamily: get(typography, 'bodyText'),
    color: get(color, 'bodyText'),
  },
  IndicatorsContainer: {
    color: get(color, 'link'),
    margin: 7,
  },
  MultiValueClose: {
    color: get(color, 'primaryButtonBackground'),
  },
});
